import { computed } from "vue";
import { useDrawingStore } from "@/stores/fileStore";
import { isDrawingSynced } from "@/utils/drawings.utils";

/**
 * Nombre de dessins locaux dont le travail n'est pas (encore) sur le serveur :
 * brouillon en attente ou synchronisation en erreur.
 */
export function useUnsyncedDrawings() {
  const drawingStore = useDrawingStore();

  const unsyncedCount = computed(() => {
    const drawings = drawingStore.localDrawings ?? [];
    return drawings.filter((d) => d.error || !isDrawingSynced(d)).length;
  });

  return { unsyncedCount };
}
